import React from 'react';
import PredictPatientList from './PredictPatientList';

/**
 * My Patients View - shows only patients assigned to current user
 */
const PredictMyPatients: React.FC = () => {
  return <PredictPatientList ownershipFilter="MY" />;
};

export default PredictMyPatients;
